export const USERID_URL = "https://mobile.mng-ads.com/cookie.html";
export const AD_BASE_URL = "https://mobile.mng-ads.com/";
export const CLOSE_BTN_URL = "//creative.mng-ads.com/MPCloseButton.png";
export const USER_ID_COOKIE_KEY = "maduserid";
export const AD_SCRIPT_VERSION = "6.0.0";
export const IFRAME_EVENTS = {
    "CLOSE":  "madvertiseMediationClose",
    "SHOW":  "madvertiseMediationShow",
    "HIDE":  "madvertiseMediationHide",
}

export const DEFAULT_PARAMETERS = {
    s: null , //Placement ID
    format: null,
    userid: null,
    mraid: null,//if tag is used for a native App, you can use true
    lat: null,//If adnetwork provide macro for GPS
    lon: null,//If adnetwork provide macro for GPS
    bundleId: null,//if tag is used for a native App and there is available macro
    age: null,//The user's age, if available (e.g macro)
    gender: null,//Gender of the user. M for male, F for female.
    tgt: null,//key/value pairs are passed in the ad request e.g adobeSegmentId=1;cat=demo
    rurl: null,//clickURL in order to track clicks
    backfillhtml: null, //Insert HTML Code here that should be shown when no ad is available
    trackingpixelurl: null, //Ping a Tracking Pixel everytime an ad is shown.
    gdpr: null,
    "consent[0][format]": null,
    "consent[0][value]": null,
    onError: null
}

